import Api from '@/services/Api'

export default {
  fetchPrices () {
    return Api().get('prices')
  },

  getPricesInCategory (fabricCategoryID) {
    return Api().get('prices/' + fabricCategoryID)
  },

  addPrice (params) {
    return Api().post('prices', params)
  },

  updatePrice (params) {
    return Api().put('price/' + params.id, params)
  },

  getPrice (params) {
    return Api().get('price/' + params.id)
  },

  deletePrice (id) {
    return Api().delete('price/' + id)
  },

  priceLookup (params) {
    return Api().post('priceLookup/', params)
  },

  pelmetLookup (params) {
    return Api().post('pelmetLookup/', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/PriceService.js